import type { Config } from '../../_config'
import type { UseCase } from '../../_kernel/architecture'
import type { Language } from '../domain/Language'
import type { SharedRepository } from '../domain/SharedRepository'
import { SharedRepositoryProxy } from '../infrastructure/SharedRepositoryProxy'

export default class GetCurrentLanguageSharedUseCase implements UseCase<undefined, Language> {
  static readonly USE_CASE_NAME = 'GetCurrentLanguageSharedUseCase'
  static create({ config, repository }: { config: Config; repository?: SharedRepository }) {
    return new GetCurrentLanguageSharedUseCase(
      repository ?? SharedRepositoryProxy.create({ config })
    )
  }

  constructor(private repository: SharedRepository) {}

  async execute() {
    return this.repository.language()
  }
}
